import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  classes?: {
    parantClass?: string;
    textClass?: string;
    textParant?: string;
  };
}

const BestValueBadge: React.FC<Props> = ({ classes }) => {
  return (
    <div
      className={twMerge(
        `bg-gradient-to-b from-[#F9742C] to-[#F20486] rounded-full flex items-center justify-center`,
        classes?.parantClass,
      )}
    >
      <div
        className={twMerge(
          `w-full h-full m-0.5 rounded-full bg-[#280e03] px-2.5 py-[5px]`,
          classes?.textParant,
        )}
      >
        <p
          className={twMerge(
            `2xl:text-sm xl:text-sm lg:text-sm md:text-[10px]  leading-[22px] 2xl:font-semibold xl:font-semibold lg:font-semibold md:font-medium text-white`,
            classes?.textClass,
          )}
        >
          % Best Value
        </p>
      </div>
    </div>
  );
};

export default BestValueBadge;
